import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { PricingList } from "../../components/pages/pricing/PricingList";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { PartnershipList } from "../../components/pages/partnerships/PartnershipList";
import { Footer } from "../../components/pages/homepage/footer/Footer";
import { usePartnershipList } from "../../hooks/react-query/usePartnershipList";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

export default function PartnershipPage() {
  const { colors } = useColors();
  const { t } = useTranslation("common");
  const { partnerships } = usePartnershipList();

  return (
    <Fragment>
      <MyHead
        title={t("partnership.name")}
        description={t("partnership.name")}
      />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color={colors.white}
          className="text-center"
        >
          {t("partnership.name")}
        </MyH1>
      </PageHeader>
      <div style={{ backgroundColor: colors.background }}>
        <Container noHeight>
          <PartnershipList />
        </Container>
      </div>
      <Footer isVisible={typeof partnerships !== "undefined"} />
    </Fragment>
  );
}
